<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Export Data') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <div
              class="btn-group">
              <button
                type="button"
                class="btn btn-light dropdown-toggle dropdown-toggle-split"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                {{ $t('Export') }}
                </button>
              <div
                class="dropdown-menu dropdown-menu-right">
                <button
                  class="dropdown-item"
                  @click="dexport('candidate')">{{ $t('Candidate XLSX') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort
                  field="entity"
                  :value="sort"
                  @input="setSort">{{ $t('Entity') }}</th-sort>
                <th-sort
                  field="status"
                  :value="sort"
                  @input="setSort">{{ $t('Status') }}</th-sort>
                <th-sort
                  field="total_items"
                  :value="sort"
                  @input="setSort">{{ $t('Total items') }}</th-sort>
                <th-sort
                  field="bytes"
                  :value="sort"
                  @input="setSort">{{ $t('Size') }}</th-sort>
                <th-sort
                  field="bytes"
                  :value="sort"
                  @input="setSort">{{ $t('Author') }}</th-sort>
                <th-sort
                  field="created_at"
                  :value="sort"
                  @input="setSort">{{ $t('Created at') }}</th-sort>
                <th-sort
                  :value="sort"
                  @input="setSort"></th-sort>
              </tr>
            </thead>
            <tbody>
              <!--
              <tr 
                v-for="(item, index) in dexports"
                :key="index">
                <td width="10"><input type="checkbox" :value="item._id" v-model="selected"></td>
                <td class="text-truncate">{{ item.title }}</td>
                <td class="text-truncate">{{ item.entity }}</td>
                <td class="text-truncate">{{ item.status }}</td>
                <td class="text-truncate">{{ item.total_items }}</td>
                <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
                <td class="text-truncate">
                  <a :href="item.url">Baixar</a>
                </td>
              </tr>
              -->
              <DexportItem
                v-for="(item, index) in dexports"
                :key="index"
                :value="item"
                @removed="loadData" />
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

    </div>
    
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import DexportItem from './DexportItem'

export default {
  name: 'Dexport',
  components: {
    ThSort,
    Paginaty,
    DexportItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    dexports () {
      return this.$store.getters.getDexports
    },
    paginate () {
      return this.$store.getters.getDexportsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page = 1) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectDexports', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    /*
    filters
    */
    setSort (sort) {
      this.sort = sort
      this.loadData()
    },
    /*
    dexport
    */
    dexport (entity) {
      this.loading = this.creating = true

      this.$store
      .dispatch('createDexport', {
        entity: entity
      })
      .then(() => {
        this.loading = false
        this.loadData(1)
      })
      .catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dexport/Dexport.vue